// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__IWsdT","info":"Footer_info__uW+dn","bold":"Footer_bold__ONL0b","menu":"Footer_menu__OrnqS","link":"Footer_link__rk5W0"};